import { Injectable } from '@angular/core';
import { User } from './entity-usuarios.model';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
  endpoint = 'user';

  constructor(
    private http: HttpClient
  ) { }

  getAll(): Observable<User[]> {
    return this.http.get<User[]>(`${environment.apiUrl}/${this.endpoint}/`);
  }
}
